import Aos from "aos";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
// import { Link } from "lucide-react";
// import { Star } from 'lucide-react';
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
// import { ChevronLeft, ChevronRight } from "lucide-react";
import "aos/dist/aos.css";
import "../../assets/css/Home.css";
import ban1 from "../../assets/image/Home/ban1.jpg";
import ban2 from "../../assets/image/Home/ban2.jpg";

// import Portfolio from '../../components/Pages/Portfolio'
import ChooseTwo from "../../assets/image/Home/choose-2.jpg";
// import test from "../../assets/image/Home/futuristic-set-with-dj-charge-music-using-virtual-reality-glasses.jpg";
// import imgLogo from "../../assets/image/Home/ICON.png";
import CaseFive from "../../assets/image/Home/carroms.avif";
import CaseTwo from "../../assets/image/Home/case-2.jpg";
import CaseThree from "../../assets/image/Home/case-3.jpg";
import CaseFour from "../../assets/image/Home/case-4.jpg";
import CaseOne from "../../assets/image/Home/case6.avif";
import ChooseThree from "../../assets/image/Home/choose-3.jpg";
import ChooseFour from "../../assets/image/Home/choose-4.jpg";
import ChooseFive from "../../assets/image/Home/choose-5.jpg";
import ChooseSix from "../../assets/image/Home/choose-6.jpg";
import ChooseSeven from "../../assets/image/Home/choose-7.jpg";
import ChooseEight from "../../assets/image/Home/choose-8.jpg";
import ChooseNine from "../../assets/image/Home/choose-9.jpg";
import n1 from "../../assets/image/Home/n1 (1).png";
import n2 from "../../assets/image/Home/n2.png";
import n3 from "../../assets/image/Home/n3.png";
import n4 from "../../assets/image/Home/n4.png";
import UserOne from "../../assets/image/Home/user-1.jpg";
import UserTwo from "../../assets/image/Home/user-2.jpg";
import UserThree from "../../assets/image/Home/user-3.jpg";
import a1 from "../../assets/image/Home/Who We Are.png";
// import aa1 from "../../assets/image/Home/Amazon_Web_Services_Logo.svg.png";
import { Col, Container, Form, Row } from "react-bootstrap";
// import { Card } from "react-bootstrap";
// import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
// import { Carousel as BootstrapCarousel } from "react-bootstrap";
import emailjs from "@emailjs/browser";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import {
  FaBuilding,
  FaPaperPlane,
  // FaStar,
  // FaRegStar,
  FaTimes,
} from "react-icons/fa";
import { IoLogoWhatsapp, IoMdBuild } from "react-icons/io";
import Footer from "../Footer/Footer";
// import LogoOne from "../../assets/image/Home/logo-1.png";
// import LogoTwo from "../../assets/image/Home/logo-2.png";
// import LogoThree from "../../assets/image/Home/logo-3.png";
// import LogoFour from "../../assets/image/Home/logo-4.png";
// import LogoFive from "../../assets/image/Home/logo-5.png";
// import LogoSix from "../../assets/image/Home/logo-6.png";
// import video2 from "../../assets/video/small.mp4";
import video3 from "../../assets/video/Final.mp4";
// import two from "../../assets/image/Home/img1.avif";
// import three from "../../assets/image/Home/img2.avif";
import imgsde from "../../assets/image/Home/img-sde.gif";
// import imggame from "../../assets/image/Home/imggame.gif";
// import imgweb from "../../assets/image/Home/imgweb.gif";
// import imgarvr from "../../assets/image/Home/imgarvr.gif";
// import imgcloud from "../../assets/image/Home/imgcloud.gif";
// import imguiux from "../../assets/image/Home/imguiux.gif";
// import imganalysis from "../../assets/image/Home/analytics_15401437.gif";
// import imgqa from "../../assets/image/Home/imgqa.gif";
// import { createRoot } from "react-dom/client";
// import { ArrowUpRight, Download } from "lucide-react";
// import img8 from "../../assets/image/itsupport/22f4fc21-d934-4056-ae3b-20303e3af23e.jpeg";
// import img11 from "../../assets/image/Home/i11.jpeg";
// import img12 from "../../assets/image/Home/i12.jpeg";
// import img13 from "../../assets/image/Home/i13.jpeg";
// import img14 from "../../assets/image/Home/i14.png";
// import img21 from "../../assets/image/Home/About Image 2.png";
import img22 from "../../assets/image/Home/About Image 1.png";
import img102 from "../../assets/image/Home/Amazon_Web_Services_Logo.svg.png";
import img23 from "../../assets/image/Home/c1.avif";
import l1 from "../../assets/image/Home/Clients - Logo (1).png";
import l2 from "../../assets/image/Home/Clients - Logo (2).png";
import l3 from "../../assets/image/Home/Clients - Logo (3).png";
import img101 from "../../assets/image/Home/img101.png";
// import { MessageCircle, X, Send, Minimize2 } from "lucide-react";
// import html from "../../assets/image/Home/html.png";
// import react from "../../assets/image/Home/react.png";
// import css from "../../assets/image/Home/css.png";
// import aws from "../../assets/image/Home/aws.png";
import { FaWhatsapp } from "react-icons/fa";
// import "../../assets/css/Portfolio.css";
import GameLogo from "../../assets/image/Game_Logo.png";
import test1 from "../../assets/image/Home/Our Games Testimonial.jpg";
// import web from "../../assets/image/Home/web.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faGlobe } from "@fortawesome/free-solid-svg-icons";

import {
  FaChartLine,
  FaEnvelope,
  FaGlobe,
  FaPhone,
  FaSkype,
  FaUser,
} from "react-icons/fa";
import IconeOne from "../../assets/image/Home/icon-1.png";
import IconeTwo from "../../assets/image/Home/icon-2.png";
import IconeThree from "../../assets/image/Home/icon-3.png";
import IconeFour from "../../assets/image/Home/icon-4.png";
import IconeFive from "../../assets/image/Home/icon-5.png";
import IconeSix from "../../assets/image/Home/icon-6.png";
import IconeSeven from "../../assets/image/Home/icon-7.png";
import IconeEight from "../../assets/image/Home/icon-8.png";
// import Image from "react-bootstrap/Image";

import { Helmet, HelmetProvider } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import "../../assets/css/Home.css";
import data from "../../Meta/Meta_ApiUrl";
import HomeBlogSection from "./HomeBlogSection";
import dyi from '../../assets/image/Home/dyi.jpg'
import pixhawk from '../../assets/image/Home/pixhawk.png'
import ardupilot from '../../assets/image/Home/ardupilot.webp'
import px4 from '../../assets/image/Home/px4.png'
import thermal from '../../assets/image/Home/thermal.webp'
import scikitlearn from '../../assets/image/Home/scikitlearn.png'
import nlp from '../../assets/image/Home/nlp.png'
import mqtt from '../../assets/image/Home/mqtt.png'
import sensor from '../../assets/image/Home/sensor.jpg'
import embeddedc from '../../assets/image/Home/embeddedc.jpg'
import nodemcu from '../../assets/image/Home/nodemcu.webp'
import ros from '../../assets/image/Home/ros.png'
import automation from '../../assets/image/Home/automation.jpg'
import embeddedsystems from '../../assets/image/Home/embeddedsystems.jpg'
import controlsystems from '../../assets/image/Home/controlsystems.jpg'
import prototyping from '../../assets/image/Home/prototyping.jpg'
import mechanicalDesgin from '../../assets/image/Home/mechanicalDesgin.jpg'
import aws from '../../assets/image/Home/aws.png'

const Home = () => {
  const [meta, setMeta] = useState({});

  useEffect(() => {
    // Directly access home_page from data
    const HomeMeta = data[0]?.home_page;

    // Set meta state if Home Meta exists
    if (HomeMeta) {
      setMeta(HomeMeta);
    }
  }, []);

  const [isOpenEnquiry, setIsOpenEnquiry] = useState(false);
  const [formDataEnquiry, setFormDataEnquiry] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });
  const form = useRef();

  // Enquiry Form functions
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpenEnquiry(true);
    }, 20000);
    return () => clearTimeout(timer);
  }, []);
  const handleClose = () => {
    setIsOpenEnquiry(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataEnquiry((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_z73r4mc", // Replace with your actual EmailJS service ID
        "template_evcmg1l", // Replace with your actual EmailJS template ID
        form.current,
        "EscxBRJBS9wDUay2E" // Replace with your actual EmailJS public key
      )
      .then(
        (result) => {
          alert("Enquiry sent successfully!");
          setIsOpenEnquiry(false);
          setFormDataEnquiry({
            name: "",
            email: "",
            phone: "",
            whatsapp: "",
            companyName: "",
            companyService: "",
            serviceType: "",
            country: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send enquiry. Please try again.");
        }
      );
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const [subscriberEmail, setSubscriberEmail] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_z73r4mc", // your service ID
        "template_2m4hu6h",

        e.target, // 👈 reference to the form
        "EscxBRJBS9wDUay2E" // 👈 from Account > API Keys
      )
      .then(
        (result) => {
          console.log("Email sent successfully:", result.text);
          alert("Subscription successful!");
        },
        (error) => {
          console.error("Email sending error:", error);
          alert("Something went wrong.");
        }
      );
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_z73r4mc", // your service ID
        // "template_2m4hu6h"
        "template_evcmg1l", // your template ID
        formData,
        "EscxBRJBS9wDUay2E" // your public key
      )
      .then(() => {
        alert("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          whatsapp: "",
          companyName: "",
          companyService: "",
          serviceType: "",
          country: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("EmailJS error:", error);
        alert("Failed to send message.");
      });
  };

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/services");
  };
  const handleClickAbout = () => {
    navigate("/about");
  };
  const handleClickGame = () => {
    navigate("/portfolio");
  };
  const handleClickTech = () => {
    navigate("/technology");
  };

  const testimonialsPrev = [
    // {
    //   id: 1,
    //   name: "CHETHAN",
    //   role: "HR/BDM Hanuvel Consultant India Pvt Ltd.",
    //   image: LogoClient_1,
    //   quote:
    //     "Your ability to work across teams and departments is a strength not everyone has. I'm impressed with the way you're working to create fabulous games.",
    //   rating: 5,
    // },
    {
      id: 1,
      name: "SIDDHARTH",
      role: "Founder Kreativation Studio",
      image: l2,
      quote:
        "I can tell how hard you've worked to be more collaborative during meetings. Your ideas are more powerful than they used to be. You've come a long way, and the team is better for it.",
      rating: 5,
    },
    {
      id: 2,
      name: "HARRY SINGH",
      role: "Founder Polc Management",
      image: l3,
      quote:
        "Very quick respond and resolve. Happy with the job. Such efficient and professional services. Excellent work and very quick turn around, Keep up the good work.",
      rating: 5,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    autoplay: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768, // md
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const renderStarsPrev = (rating) => {
    return [...Array(5)].map((_, i) => (
      <i
        key={i}
        className={`bi ${i < rating ? "bi-star-fill text-warning" : "bi-star text-secondary"
          }`}
      />
    ));
  };

  const [currentSlide1, setcurrentSlide1] = useState(0);

  const testimonialsnew = [
    {
      id: 1,
      name: "ANDRU SMITH",
      role: "Boxing Trainer",
      image:
        "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=150&h=150&fit=crop&crop=face",
      quote:
        "We teach martial arts because we love it — not because we want anything from you. Unlike other martial arts programs",
      rating: 5,
    },

    {
      id: 3,
      name: "MIKE TYSON",
      role: "Professional Boxer",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      quote:
        "The training here is intense and professional. Every session pushes you to your limits and beyond.",
      rating: 5,
    },
    {
      id: 4,
      name: "SARAH CONNOR",
      role: "Fitness Trainer",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      quote:
        "Amazing facility with top-notch equipment. The trainers are professional and really care about your progress.",
      rating: 5,
    },
    {
      id: 5,
      name: "JOHN WARRIOR",
      role: "MMA Fighter",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      quote:
        "Best martial arts school in the city. The techniques taught here are authentic and effective for real combat.",
      rating: 5,
    },
    {
      id: 6,
      name: "LISA POWER",
      role: "Kickboxing Instructor",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
      quote:
        "The community here is incredible. Everyone supports each other and the training is world-class.",
      rating: 5,
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setcurrentSlide1((prev) => (prev + 1) % testimonialsnew.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [testimonialsnew.length]);

  const sliderRef = useRef();

  const prevSlidenew = () => {
    sliderRef.current?.slickPrev();
  };

  const nextSlidenew = () => {
    sliderRef.current?.slickNext();
  };

  const goToSlidenew = (index) => {
    setcurrentSlide1(index);
  };

  const renderStarsnew = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        size={16}
        className={i < rating ? "text-warning" : "text-muted"}
        fill={i < rating ? "currentColor" : "none"}
      />
    ));
  };

  const getVisibletestimonialsnew = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentSlide1 + i) % testimonialsnew.length;
      visible.push(testimonialsnew[index]);
    }
    return visible;
  };

  // tochnology section
  const technologyDomains = {
    drone: [
      { name: "DJI", icon: dyi },
      { name: "Pixhawk", icon: pixhawk },
      { name: "ArduPilot", icon: ardupilot },
      { name: "PX4", icon: px4 },
      // { name: "RTK GPS", icon: imgDrone5 },
      { name: "Thermal Camera", icon: thermal },
    ],

    ai: [
      { name: "TensorFlow", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg" },
      { name: "PyTorch", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg" },
      { name: "OpenCV", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/opencv/opencv-original.svg" },
      { name: "Python", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
      { name: "Scikit-Learn", icon: scikitlearn },
      { name: "NLP", icon: nlp },
    ],

    iot: [
      { name: "Arduino", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/arduino/arduino-original.svg" },
      { name: "Raspberry Pi", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/raspberrypi/raspberrypi-original.svg" },
      { name: "MQTT", icon: mqtt },
      { name: "Sensors", icon: sensor },
      { name: "Embedded C", icon: embeddedc },
      { name: "NodeMCU", icon: nodemcu },
    ],

    robotics: [
      { name: "ROS", icon: ros },
      { name: "Automation", icon: automation },
      { name: "Embedded Systems", icon: embeddedsystems },
      { name: "Control Systems", icon: controlsystems },
      { name: "Mechanical Design", icon: mechanicalDesgin },
      { name: "Prototyping", icon: prototyping },
    ],

    development: [
      { name: "React", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
      { name: "Node.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
      { name: "MongoDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" },
      { name: "AWS", icon: aws },
      { name: "Docker", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
      { name: "Git", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" },
    ],
  };

  const [currentDomain, setCurrentDomain] = useState("drone");
  const [animationKey, setAnimationKey] = useState(0);

  useEffect(() => {
    const domains = Object.keys(technologyDomains);
    const interval = setInterval(() => {
      setCurrentDomain((prev) => {
        const currentIndex = domains.indexOf(prev);
        const nextIndex = (currentIndex + 1) % domains.length;
        return domains[nextIndex];
      });
      setAnimationKey((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const getDomainColor = (domain) => {
    const colors = {
      frontend: { bg: "bg-white", border: "border-white", text: "text-dark" },
      backend: { bg: "bg-white", border: "border-white", text: "text-dark" },
      database: { bg: "bg-white", border: "border-white", text: "text-dark" },
      devops: { bg: "bg-white", border: "border-white", text: "text-dark" },
    };
    return colors[domain] || colors.frontend;
  };

  const getDomainName = (domain) => {
    const names = {
      drone: "Drone Technology",
      ai: "Artificial Intelligence",
      iot: "IoT & Smart Systems",
      robotics: "Robotics Engineering",
      development: "Software & Cloud",
    };
    return names[domain];
  };

  const currentTechs = technologyDomains[currentDomain];
  const domainColors = getDomainColor(currentDomain);

  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isLoaded, setIsLoaded] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const gamerImages = [
    {
      id: 1,
      bg: "linear-gradient(to bottom right, #4ade80, #22d3ee, #3b82f6)",
      accent: "linear-gradient(to right, #22c55e, #06b6d4)",
      lighting:
        "linear-gradient(to top, rgba(74, 222, 128, 0.3), rgba(34, 211, 238, 0.3))",
    },
    {
      id: 2,
      bg: "linear-gradient(to bottom right, #a855f7, #ec4899, #ef4444)",
      accent: "linear-gradient(to right, #9333ea, #db2777)",
      lighting:
        "linear-gradient(to top, rgba(168, 85, 247, 0.3), rgba(236, 72, 153, 0.3))",
    },
    {
      id: 3,
      bg: "linear-gradient(to bottom right, #fb923c, #ef4444, #ec4899)",
      accent: "linear-gradient(to right, #f97316, #dc2626)",
      lighting:
        "linear-gradient(to top, rgba(251, 146, 60, 0.3), rgba(236, 72, 153, 0.3))",
    },
    {
      id: 4,
      bg: "linear-gradient(to bottom right, #22d3ee, #3b82f6, #a855f7)",
      accent: "linear-gradient(to right, #06b6d4, #2563eb)",
      lighting:
        "linear-gradient(to top, rgba(34, 211, 238, 0.3), rgba(168, 85, 247, 0.3))",
    },
  ];

  useEffect(() => {
    setIsLoaded(true);

    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      });
    };

    const imageInterval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % gamerImages.length);
    }, 3000);

    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      clearInterval(imageInterval);
    };
  }, []);

  const getVisibleImages1 = () => [
    { id: 1, src: n1 },
    { id: 2, src: n2 },
    { id: 3, src: n3 },
    { id: 4, src: n4 },
  ];

  // 👇 Now safely use these functions
  const images1 = [...getVisibleImages1()];
  const [counters, setCounters] = useState({
    years: 0,
    specialists: 0,
    games: 0,
    clients: 0,
  });

  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  // Counter animation function
  const animateCounter = (target, key, duration = 2000, suffix = "") => {
    const start = 0;
    const startTime = Date.now();

    const updateCounter = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const current = Math.floor(start + (target - start) * easeOutQuart);

      setCounters((prev) => ({
        ...prev,
        [key]: current,
      }));

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      }
    };

    requestAnimationFrame(updateCounter);
  };

  // Intersection Observer for triggering animation when in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);

          // Start all counter animations with slight delays
          setTimeout(() => animateCounter(15, "years"), 500);
          setTimeout(() => animateCounter(100, "specialists"), 700);
          setTimeout(() => animateCounter(75, "games"), 900);
          setTimeout(() => animateCounter(30, "clients"), 1100);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated]);

  const formatNumber = (num, suffix) => {
    if (suffix === "K") {
      return `${num}K`;
    }
    return num;
  };

  const [isSpinning, setIsSpinning] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [isAutoRotating, setIsAutoRotating] = useState(true);

  // Auto rotation effect
  useEffect(() => {
    let interval;
    if (isAutoRotating && !isSpinning) {
      interval = setInterval(() => {
        setRotation((prev) => prev + 0.5); // Slow continuous rotation
      }, 50); // Update every 50ms for smooth rotation
    }
    return () => clearInterval(interval);
  }, [isAutoRotating, isSpinning]);

  // European roulette numbers in order
  const numbers = [
    { num: 0, color: "green" },
    { num: 32, color: "red" },
    { num: 15, color: "black" },
    { num: 19, color: "red" },
    { num: 4, color: "black" },
    { num: 21, color: "red" },
    { num: 2, color: "black" },
    { num: 25, color: "red" },
    { num: 17, color: "black" },
    { num: 34, color: "red" },
    { num: 6, color: "black" },
    { num: 27, color: "red" },
    { num: 13, color: "black" },
    { num: 36, color: "red" },
    { num: 11, color: "black" },
    { num: 30, color: "red" },
    { num: 8, color: "black" },
    { num: 23, color: "red" },
    { num: 10, color: "black" },
    { num: 5, color: "red" },
    { num: 24, color: "black" },
    { num: 16, color: "red" },
    { num: 33, color: "black" },
    { num: 1, color: "red" },
    { num: 20, color: "black" },
    { num: 14, color: "red" },
    { num: 31, color: "black" },
    { num: 9, color: "red" },
    { num: 22, color: "black" },
    { num: 18, color: "red" },
    { num: 29, color: "black" },
    { num: 7, color: "red" },
    { num: 28, color: "black" },
    { num: 12, color: "red" },
    { num: 35, color: "black" },
    { num: 3, color: "red" },
    { num: 26, color: "black" },
  ];

  const spinWheel = () => {
    if (isSpinning) return;

    setIsSpinning(true);
    const spins = 5 + Math.random() * 5; // 5-10 full rotations
    const finalRotation = rotation + spins * 360 + Math.random() * 360;
    setRotation(finalRotation);

    setTimeout(() => {
      setIsSpinning(false);
    }, 4000);
  };

  const resetWheel = () => {
    if (isSpinning) return;
    setRotation(0);
  };

  const toggleAutoRotation = () => {
    setIsAutoRotating(!isAutoRotating);
  };

  const [hoveredCard, setHoveredCard] = React.useState(null);

  const handleCardHover = (cardIndex) => {
    setHoveredCard(cardIndex);
  };

  const handleCardLeave = () => {
    setHoveredCard(null);
  };

  useEffect(() => {
    // Initialize AOS
    if (typeof window !== "undefined") {
      // Create and inject AOS CSS
      const aosCSS = document.createElement("link");
      aosCSS.rel = "stylesheet";
      aosCSS.href = "https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.css";
      document.head.appendChild(aosCSS);

      // Create and inject AOS JS
      const aosScript = document.createElement("script");
      aosScript.src = "https://cdnjs.cloudflare.com/ajax/libs/aos/2.3.4/aos.js";
      aosScript.onload = () => {
        window.AOS.init({
          duration: 1000,
          once: true,
          offset: 100,
        });
      };
      document.head.appendChild(aosScript);

      // Create and inject Bootstrap CSS
      const bootstrapCSS = document.createElement("link");
      bootstrapCSS.rel = "stylesheet";
      bootstrapCSS.href =
        "https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css";
      document.head.appendChild(bootstrapCSS);
    }
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [CaseTwo, CaseOne, CaseThree, CaseOne, CaseTwo, CaseThree];
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentIndex1, setCurrentIndex1] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const cardData = [
    {
      title: "Ludo Games",
      description: "Rummy nights, endless delights!",
      rating: 4,
      review: "Ludo brings back childhood fun with a competitive twist!",
      image: CaseOne,
    },
    {
      title: "Rummy Games",
      description: "Rummy On. Game Strong.",
      rating: 5,
      review: "Smooth gameplay and great rewards — best rummy app I’ve used!",
      image: CaseTwo,
    },
    {
      title: "Fantasy Sports",
      description: "Your game, your rules, your fantasy!.",
      rating: 3,
      review: "Create your dream team and win big – fantasy sports done right!",
      image: CaseThree,
    },
    {
      title: "Chess",
      description: "Master the board. Rule the mind.",
      rating: 4,
      review:
        "Sharpen your mind — this chess game is both elegant and intense.",
      image: CaseFour,
    },
    {
      title: "Carrom Games",
      description: "Aim. Strike. Pocket the win.",
      rating: 5,
      review:
        "Feels just like the real board — best digital Carrom experience!",
      image: CaseFive,
    },
  ];

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
      offset: 100,
      easing: "ease-in-out",
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1200 },
      items: 3,
    },
    desktop: {
      breakpoint: { max: 1200, min: 768 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 768, min: 576 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
    },
  };

  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Marketing Director",
      company: "TechCorp Inc.",
      image: UserOne,
      rating: 5,
      review:
        "This product has completely transformed how we handle our marketing campaigns. The intuitive interface and powerful features have increased our team's productivity by 40%.",
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "CEO",
      company: "StartupXYZ",
      image: UserTwo,
      rating: 5,
      review:
        "Outstanding service and support! The team went above and beyond to ensure our implementation was smooth. The ROI we've seen in just three months has exceeded all expectations.",
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      role: "Product Manager",
      company: "InnovateLab",
      image: UserThree,
      rating: 5,
      review:
        "A game-changer for our workflow! The automation features alone have saved us countless hours each week. The customer support is also top-notch - always responsive and helpful.",
    },
  ];

  const nextSlide = useCallback(() => {
    setCurrentIndex1((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  }, [testimonials.length]);

  const prevSlide = () => {
    setCurrentIndex1((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex1(index);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 8000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    if (isLeftSwipe) {
      nextSlide();
    }
    if (isRightSwipe) {
      prevSlide();
    }
  };

  const currentTestimonial = testimonials[currentIndex1];

  const features = [
    { title: "SOFTWARE DEVELOPMENT", img: imgsde },
    { title: "GAME DEVELOPMENT", img: ChooseTwo },
    { title: "AR/VR APPLICATION DEVELOPMENT", img: ChooseThree },
    { title: "CASINO & SPORTSBOOK API INTEGRATION", img: ChooseNine },
    { title: "WEBSITE DEVELOPMENT", img: ChooseFour },
    { title: "APP DEVELOPMENT", img: ChooseFive },
    { title: "DEVOPS SOLUTIONS", img: ChooseSix },
    { title: "IT SUPPORT & SOLUTIONS", img: ChooseSeven },
    { title: "DIGITAL MARKETING", img: ChooseEight },
  ];

  const [activeIndex1, setActiveIndex1] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const slides = [
    {
      title: "Building Intelligent Digital Solutions",
      subtitle: "AI, Drones, IoT & Next-Gen Technologies",
      description:
        "We craft smart, scalable, and future-ready solutions for startups and enterprises.",
      primaryBtn: "Start a Project →",
      link: "/",
    },
    {
      title: "Transforming Ideas into Innovation",
      subtitle: "",
      description:
        "From concept to deployment, we develop advanced systems powered by AI, Robotics, and Automation.",
      primaryBtn: "Explore Services →",
      link: "/services",
    },
    {
      title: "Empowering Businesses with Technology",
      subtitle: "",
      description:
        "Delivering intelligent applications, connected systems, and immersive digital experiences.",
      primaryBtn: "Contact Us →",
      link: "/contact",
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const slide = slides[currentSlide];

  const handleIndicatorClick = (index) => {
    console.log("Indicator clicked:", index, "Current active:", activeIndex1);
    if (index !== activeIndex1 && !isTransitioning) {
      setIsTransitioning(true);
      setActiveIndex1(index);
    }
  };

  const handlePrev = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setActiveIndex1((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    }
  };

  const handleNext = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setActiveIndex1((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTransitioning(false);
    }, 800);
    return () => clearTimeout(timer);
  }, [activeIndex1]);

  // Auto-advance carousel
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isTransitioning) {
        handleNext();
      }
    }, 6000);
    return () => clearInterval(interval);
  }, [isTransitioning]);

  const scrollWrapperStyle = {
    overflow: "hidden",
    width: "100%",
    position: "relative",
  };

  const scrollTrackStyle = {
    display: "flex",
    animation: "continuousScroll 20s linear infinite",
    width: "max-content",
  };

  const imageBoxStyle = {
    flex: "0 0 auto",
    marginRight: "1rem",
  };

  const imageStyle = {
    height: "400px",
    width: "200px",
    objectFit: "cover",
    borderRadius: "8px",
  };

  const [hoveredCard1, setHoveredCard1] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const services = [
    {
      icon: (
        <img
          src={IconeOne}
          alt="Drone Solutions"
          style={{ width: "58px", height: "58px" }}
        />
      ),
      title: "Drone Services & Education",
      description:
        "Our Drone Division provides end-to-end aerial solutions designed to improve efficiency, reduce risks, and deliver highly accurate data across industries.",
    },
    {
      icon: (
        <img
          src={IconeSeven}
          alt="IoT Solutions"
          style={{ width: "58px", height: "58px" }}
        />
      ),
      title: "IoT SOLUTIONS",
      description:
        "Design and implement smart connected devices, automation systems, and real-time data solutions for modern businesses.",
    },
    {
      icon: (
        <img
          src={IconeSeven}
          alt="IoT Solutions"
          style={{ width: "58px", height: "58px" }}
        />
      ),
      title: "ROBOTICS SOLUTIONS",
      description:
        "Develop intelligent robotic systems for automation, industrial applications, and real-world problem-solving.",
    },
    {
      icon: (
        <img
          src={IconeSeven}
          alt="IoT Solutions"
          style={{ width: "58px", height: "58px" }}
        />
      ),
      title: "AI",
      description:
        "Build AI-powered applications including machine learning models, predictive analytics, and intelligent automation.",
    },
    // {
    //   icon: (
    //     <img
    //       src={IconeOne}
    //       alt="Game Development"
    //       style={{ width: "58px", height: "58px" }}
    //     />
    //   ),
    //   title: "SOFTWARE DEVELOPMENT",
    //   description:
    //     "We offer robust software development solutions designed to streamline your business processes and drive efficiency.",
    // },
    // {
    //   icon: (
    //     <img
    //       src={IconeTwo}
    //       alt="Game Development"
    //       style={{ width: "58px", height: "58px" }}
    //     />
    //   ),
    //   title: "GAME DEVELOPMENT",
    //   description:
    //     "2D & 3D Games, Casual Games, and Engaging Skill-Oriented Experiences",
    // },
    {
      icon: (
        <img
          src={IconeThree}
          alt="Game Development"
          style={{ width: "58px", height: "58px" }}
        />
      ),
      title: "WEBSITE DEVELOPMENT",
      description:
        "Static & Dynamic Websites, Responsive Design, we deliver an exceptional user experience.",
    },
    // {
    //   icon: (
    //     <img
    //       src={IconeFour}
    //       alt="Game Development"
    //       style={{ width: "58px", height: "58px" }}
    //     />
    //   ),
    //   title: "AR/VR DEVELOPMENT",
    //   description:
    //     "Augmented Reality (AR) Solutions, Virtual Reality (VR) Games and Applications real-world interactions.",
    // },
    // {
    //   icon: (
    //     <img
    //       src={IconeFive}
    //       alt="Game Development"
    //       style={{ width: "58px", height: "58px" }}
    //     />
    //   ),
    //   title: "CLOUD SERVICES",
    //   description:
    //     "CI/CD pipelines, containerization, and scalable cloud solutions for modern infrastructure.",
    // },
    // {
    //   icon: (
    //     <img
    //       src={IconeSix}
    //       alt="Game Development"
    //       style={{ width: "58px", height: "58px" }}
    //     />
    //   ),
    //   title: "UI/UX DESIGN",
    //   description:
    //     "Human-centered design with intuitive user experiences and beautiful visuals.",
    // },


    // {
    //   icon: (
    //     <img
    //       src={IconeEight}
    //       alt="Game Development"
    //       style={{ width: "58px", height: "58px" }}
    //     />
    //   ),
    //   title: "DATA ANALYTICS",
    //   description:
    //     "Build data-driven strategies with dashboards, analytics, and AI-powered models.",
    // },
  ];
  const [hovered, setHovered] = useState(false);
  const [hoveredToggle, setHoveredToggle] = useState(false);

  const [isOpen1, setIsOpen1] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Hello! How can we assist you today?",
      time: "10:00 AM",
      sender: "bot",
    },
  ]);

  const sendMessage = () => {
    if (!message.trim()) return;

    const newMessage = {
      id: messages.length + 1,
      text: message,
      time: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
      sender: "user",
    };

    setMessages([...messages, newMessage]);
    setMessage("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "2px solid #e9ecef",
    borderRadius: "10px",
    fontSize: "0.95rem",
    background: "white",
    outline: "none",
    transition: "all 0.3s ease",
  };

  return (
    <HelmetProvider>
      <div style={{ overflowX: "hidden" }}>
        <Helmet>
          <title>{meta?.title || "Home - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED, officially registered as SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED IT Solutions Private Limited, is a game and app development company based in Tamil Nadu, India."
            }
          />
        </Helmet>
        {/* Enquiry Form */}
        {isOpenEnquiry && (
          <div
            onClick={handleBackdropClick}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(8px)",
              zIndex: 1050,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "650px",
                maxHeight: "100vh",
                background: "#fff",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 15px 50px rgba(0,0,0,0.25)",
              }}
            >
              {/* Fixed Header */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#00b7eb",
                  color: "#ffffff",
                  padding: "15px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    textAlign: "center",
                  }}
                >
                  Enquiry Form
                </h3>
                <button
                  onClick={handleClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#ffffff",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Scrollable Form */}
              <div
                style={{
                  padding: "20px",
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 70px)", // Adjust based on header height
                }}
              >
                <form ref={form} onSubmit={handleSubmitForm}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {/* Full Name */}
                    <div>
                      <FaUser
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formDataEnquiry.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter full name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <FaEnvelope
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formDataEnquiry.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter email"
                        style={inputStyle}
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <FaPhone
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formDataEnquiry.phone}
                        onChange={handleInputChange}
                        placeholder="Enter phone"
                        style={inputStyle}
                      />
                    </div>

                    {/* WhatsApp */}
                    <div>
                      <IoLogoWhatsapp
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">WhatsApp</label>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formDataEnquiry.whatsapp}
                        onChange={handleInputChange}
                        placeholder="Enter WhatsApp"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Name */}
                    <div>
                      <FaBuilding
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        value={formDataEnquiry.companyName}
                        onChange={handleInputChange}
                        placeholder="Enter company name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Service */}
                    <div>
                      <IoMdBuild
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Service</label>
                      <select
                        name="companyService"
                        value={formDataEnquiry.companyService}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Solo">Solo</option>
                        <option value="Pvt">Pvt</option>
                        <option value="LLP">LLP</option>
                        <option value="Startup">Startup</option>
                        <option value="Partnership">Partnership</option>
                      </select>
                    </div>

                    {/* Service Type */}
                    <div>
                      <MdOutlineMiscellaneousServices
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Type of Service</label>
                      <select
                        name="serviceType"
                        value={formDataEnquiry.serviceType}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Drone">Drone Solutions</option>
                        <option value="Robotics">Robotics Solutions</option>
                        <option value="IOT">Iot Solutions</option>
                        <option value="AI">Artificial Intelligence</option>
                        <option value="Software">Software Development</option>
                        <option value="App">App Development</option>
                        {/* <option value="Game">Game Development</option> */}
                        <option value="Website">Website Development</option>
                        <option value="AR & VR Development">
                          AR & VR Apps
                        </option>
                        {/* <option value="Casino Api">Casino API</option> */}
                        {/* <option value="Devops Solutions">DevOps</option> */}
                        {/* <option value="It Support">IT Support</option> */}
                        <option value="Training Programs">Training</option>
                        <option value="Digital Marketing">
                          Digital Marketing
                        </option>
                      </select>
                    </div>

                    {/* Country */}
                    <div>
                      <FaGlobe
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={formDataEnquiry.country}
                        onChange={handleInputChange}
                        placeholder="Enter country"
                        style={inputStyle}
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label className="fw-bold">Your Message *</label>
                    <textarea
                      name="message"
                      value={formDataEnquiry.message}
                      onChange={handleInputChange}
                      required
                      rows={1}
                      placeholder="Tell us about your requirements..."
                      style={{
                        ...inputStyle,
                        resize: "vertical",
                      }}
                    />
                  </div>

                  {/* Submit Button */}
                  <div
                    className="mt-1 margin-top-home"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      type="submit"
                      style={{
                        background: "#00b7eb",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "25px",
                        fontWeight: "600",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaPaperPlane style={{ marginRight: "8px" }} />
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Background Video */}
        <div className="position-relative w-100 vh-100 vh-sm-50 overflow-hidden">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="position-absolute top-0 start-0 w-100 h-sm-50 h-100"
            src={video3}
            style={{ objectFit: "cover", zIndex: 0 }}
          />

          <div
            className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
            style={{ zIndex: 1 }}
          ></div>

          <div
            className="position-relative h-100 d-flex align-items-center justify-content-center"
            style={{ zIndex: 2 }}
          >
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center px-3 px-sm-4 px-md-5 text-white`}
                style={{
                  opacity: index === activeIndex1 ? 1 : 0,
                  visibility: index === activeIndex1 ? "visible" : "hidden",
                  transition: "all 0.6s cubic-bezier(0.4, 0.0, 0.2, 1)",
                  transform:
                    index === activeIndex1
                      ? "translateY(0) scale(1)"
                      : "translateY(20px) scale(0.95)",
                  zIndex: index === activeIndex1 ? 3 : 2,
                }}
              >
                <div className="text-center">
                  <h2
                    className="display-3 fw-bold text-white mb-3"
                    style={{
                      transition: "all 0.8s cubic-bezier(0.4, 0.0, 0.2, 1)",
                      transitionDelay: index === activeIndex1 ? "0.2s" : "0s",
                      transform:
                        index === activeIndex1
                          ? "translateY(0)"
                          : "translateY(30px)",
                      opacity: index === activeIndex1 ? 1 : 0,
                    }}
                  >
                    {slide.title}
                    {slide.subtitle && (
                      <>
                        <br className="d-none d-md-block" />
                        {slide.subtitle}
                      </>
                    )}
                  </h2>

                  <div
                    className="text-white fw-semibold fs-5 mb-5"
                    style={{
                      transition: "all 0.8s cubic-bezier(0.4, 0.0, 0.2, 1)",
                      transitionDelay: index === activeIndex1 ? "0.4s" : "0s",
                      transform:
                        index === activeIndex1
                          ? "translateY(0)"
                          : "translateY(30px)",
                      opacity: index === activeIndex1 ? 1 : 0,
                    }}
                  >
                    {slide.description}
                  </div>

                  <div
                    className="d-flex flex-column flex-sm-row gap-3 justify-content-center"
                    style={{
                      transition: "all 0.8s cubic-bezier(0.4, 0.0, 0.2, 1)",
                      transitionDelay: index === activeIndex1 ? "0.6s" : "0s",
                      transform:
                        index === activeIndex1
                          ? "translateY(0)"
                          : "translateY(30px)",
                      opacity: index === activeIndex1 ? 1 : 0,
                    }}
                  >
                    <div className="text-center ">
                      <button
                        className="btn btn-danger text-white fw-semibold 
          px-2 px-sm-4 px-md-4 
          py-1 py-sm-2 py-md-2 
          fs-6 fs-sm-5 fs-md-4 
          shadow-sm transition-hover"
                        onClick={() => navigate(slide.link)}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-2px)";
                          e.target.style.boxShadow =
                            "0 8px 25px rgba(222, 31, 38, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow =
                            "0 4px 15px rgba(222, 31, 38, 0.3)";
                        }}
                      >
                        {slide.primaryBtn}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            className="position-absolute top-50 start-0 translate-middle-y btn p-0"
            onClick={handlePrev}
            style={{
              fontSize: "2rem",
              marginLeft: "20px",
              transition: "all 0.3s ease",
              zIndex: 10,
              background: "rgba(0,0,0,0.2)",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              border: "none",
              color: "white",
              textDecoration: "none",
              boxShadow: "none",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-50%) scale(1.1)";
              e.target.style.background = "rgba(0,0,0,0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(-50%) scale(1)";
              e.target.style.background = "rgba(0,0,0,0.2)";
            }}
          >
            ←
          </button>

          <button
            className="position-absolute top-50 end-0 translate-middle-y btn p-0"
            onClick={handleNext}
            style={{
              fontSize: "2rem",
              marginRight: "20px",
              transition: "all 0.3s ease",
              zIndex: 10,
              background: "rgba(0,0,0,0.2)",
              borderRadius: "50%",
              width: "50px",
              height: "50px",
              border: "none",
              color: "white",
              textDecoration: "none",
              boxShadow: "none",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-50%) scale(1.1)";
              e.target.style.background = "rgba(0,0,0,0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(-50%) scale(1)";
              e.target.style.background = "rgba(0,0,0,0.2)";
            }}
          >
            →
          </button>

          <div
            className="position-absolute bottom-0 start-50 translate-middle-x mb-4 d-flex gap-3"
            style={{ zIndex: 10 }}
          >
            {slides.map((_, index) => (
              <button
                key={index}
                className="btn p-0 border-0"
                onClick={() => handleIndicatorClick(index)}
                style={{
                  width: "14px",
                  height: "14px",
                  borderRadius: "50%",
                  backgroundColor:
                    index === activeIndex1
                      ? "#00b7eb"
                      : "rgba(255, 255, 255, 0.5)",
                  transition: "all 0.4s cubic-bezier(0.4, 0.0, 0.2, 1)",
                  transform: index === activeIndex1 ? "scale(1.4)" : "scale(1)",
                  boxShadow:
                    index === activeIndex1
                      ? "0 0 15px rgba(222, 31, 38, 0.8)"
                      : "0 0 5px rgba(255, 255, 255, 0.3)",
                  cursor: "pointer",
                }}
              />
            ))}
          </div>
        </div>

        <div
          className="container-fluid "
          style={{ marginTop: "55px", minHeight: "35vh" }}
        >
          <div className="container-fluid ">
            <div className="row align-items-center justify-content-center min-vh-35">
              {/* Images Section */}
              <div className="col-lg-6 col-md-8 col-12 mb-lg-4 mb-md-4 mb-sm-1  order-2 order-lg-1 d-none d-lg-block">
                <div
                  className="position-relative mx-auto"
                  style={{
                    maxWidth: "500px",
                    height: "500px",
                    marginTop: "40px",
                  }}
                >
                  {/* Gaming Setup Image - Background Layer */}
                  <div
                    className="position-absolute gaming-setup-img"
                    style={{
                      top: "25%",
                      left: "5%",
                      width: "65%",
                      height: "80%",
                      zIndex: 2,
                      borderRadius: "15px",
                      overflow: "hidden",
                      borderTopRightRadius: "180px",
                    }}
                    data-aos="fade-right"
                    data-aos-duration="2000"
                  >
                    <img
                      src={ban2}
                      alt="Gaming Setup"
                      className="w-100 h-100"
                      style={{
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  </div>

                  {/* Player Portrait Image - Foreground Layer */}
                  <div
                    className="position-absolute player-portrait-img"
                    style={{
                      top: "0",
                      right: "0",
                      width: "60%",
                      height: "80%",
                      zIndex: 1,

                      overflow: "hidden",
                    }}
                    data-aos="fade-left"
                    data-aos-duration="2000"
                    data-aos-delay="200"
                  >
                    <img
                      src={ban1}
                      alt="Pro Player Portrait"
                      className="w-100 h-100"
                      style={{
                        objectFit: "cover",
                        objectPosition: "center top",
                      }}
                    />
                    {/* Portrait overlay gradient */}
                    <div
                      className="position-absolute w-100 h-100"
                      style={{
                        top: 0,
                        left: 0,
                        background:
                          "linear-gradient(135deg, rgba(138, 43, 226, 0.1) 0%, rgba(255, 0, 150, 0.1) 100%)",
                        mixBlendMode: "overlay",
                      }}
                    ></div>
                  </div>

                  {/* Decorative Background Circle */}
                  <div
                    className="position-absolute d-none d-md-block"
                    style={{
                      top: "60%",
                      left: "30%",
                      transform: "translate(-50%, -50%)",
                      width: "300px",
                      height: "300px",

                      borderRadius: "50%",
                      zIndex: 2,
                    }}
                  ></div>
                </div>
              </div>

              {/* Content Section */}
              <div className="col-lg-6 col-12 mb-3 order-1 order-lg-2">
                <div className="px-lg-4 px-3">
                  {/* Who We Are Badge */}
                  <div
                    className="mb-2 mb-md-4"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <button
                      className="btn border border-danger fw-semibold bg-transparent px-3 py-2 rounded-pill fs-6 fs-md-5"
                      style={{ cursor: "default", color: "#00b7eb" }}
                    >
                      WHO WE ARE
                    </button>
                  </div>

                  {/* Main Heading */}
                  <h3
                    className="display-5 display-md-4 fw-bold mb-3 mb-md-4 text-dark lh-sm"
                    data-aos="fade-up"
                    data-aos-duration="1500"
                    data-aos-delay="300"
                  >
                    Innovating the Future with Smart Technologies
                  </h3>

                  {/* Description */}
                  <p
                    className="font-para text-dark justifycontent mb-4 mb-md-5"
                    style={{ lineHeight: "1.5" }}
                    data-aos="fade-up"
                    data-aos-duration="1500"
                    data-aos-delay="400"
                  >
                    At <b>SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED</b>, we specialize in
                    building intelligent and future-ready solutions across Drone Technology,
                    Artificial Intelligence (AI), Internet of Things (IoT), and Robotics.
                    <br /><br />
                    We deliver end-to-end technology solutions—from aerial intelligence and
                    smart automation to connected systems and AI-driven applications—helping
                    businesses improve efficiency, reduce risk, and make smarter decisions.
                    <br /><br />
                    Our mission is to bridge innovation with real-world implementation,
                    empowering industries to adapt, grow, and lead in a rapidly evolving
                    digital landscape.
                  </p>

                  {/* Call to Action Button */}
                  <div className="mt-4" data-aos="fade-up" data-aos-delay="500">
                    <button
                      className="btn btn-red text-white fw-semibold px-4 py-2"
                      onClick={handleClickAbout}
                    >
                      About Us →
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Custom CSS for additional responsive improvements */}
          <style>{`
            @media (max-width: 576px) {
              .gaming-setup-img {
                top: 25% !important;
                left: 10% !important;
                width: 70% !important;
                height: 60% !important;
              }

              .player-portrait-img {
                top: 5% !important;
                right: 5% !important;
                width: 65% !important;
                height: 70% !important;
              }
            }

            @media (max-width: 768px) {
              .gaming-setup-img {
                top: 22% !important;
                left: 12% !important;
                width: 68% !important;
                height: 65% !important;
              }

              .player-portrait-img {
                top: 2% !important;
                right: 8% !important;
                width: 62% !important;
                height: 75% !important;
              }
            }

            @media (min-width: 992px) {
              .min-vh-75 {
                min-height: 75vh;
              }
            }
          `}</style>
        </div>

        <div
          className="container-fluid  bg-light"
          data-aos="fade-up"
          style={{ marginTop: "20px" }}
        ></div>

        <style>{`
          .services-section {
            min-height: 70vh;
            background-color: #f8f9fa;
            padding: 2rem 0;
          }

          .services-badge {
            display: inline-block;
            padding: 0.5rem 1.5rem;
            border: 2px solid #dc3545;
            color: #dc3545;
            border-radius: 50px;
            font-size: 0.875rem;
            font-weight: 500;
            margin-bottom: 1.5rem;
          }

          .services-title {
            font-size: 3rem;
            font-weight: bold;
            color: #212529;
            margin-bottom: 1rem;
          }

          .services-description {
            color: #6c757d;
            font-size: 1.125rem;
            max-width: 32rem;
          }

          .explore-btn {
            background-color: #dc3545;
            border: none;
            color: white;
            padding: 0.75rem 2rem;
            border-radius: 0.5rem;
            font-weight: 600;
            transition: all 0.3s ease;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          }

          .explore-btn:hover {
            background-color: #c82333;
            transform: scale(1.05);
          }

          .service-card {
            background: white;
            padding: 1rem;
            border-radius: 0.75rem;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
            cursor: pointer;
            height: 230px;
            border: none;
          }

          .service-card:hover {
            // box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
            transform: translateY(-8px);
          }

          .service-icon {
            margin-bottom: 1.5rem;
            transition: transform 0.3s ease;
          }

          .service-card:hover .service-icon {
            transform: scale(1.1);
          }

          .service-title {
            color: #dc3545;
            font-weight: bold;
            font-size: 1.225rem;
            margin-bottom: 1rem;
            transition: color 0.3s ease;
          }

          .service-card:hover .service-title {
            color: #c82333;
          }

          .service-text {
            color: #6c757d;
            font-size: 0.875rem;
            line-height: 1.6;
          }

          @media (max-width: 768px) {
            .services-title {
              font-size: 2.5rem;
            }

            .header-section {
              flex-direction: column;
              align-items: flex-start !important;
            }

            .explore-btn {
              margin-top: 1rem;
            }
          }
        `}</style>

        <div className="services-section">
          <div className="container">
            {/* Header Section */}
            <div className="d-flex justify-content-between align-items-center header-section">
              <div>
                <button
                  className="btn border border-danger fw-semibold bg-transparent px-3 py-1 mb-2 rounded-pill fs-6 fs-md-5"
                  style={{ cursor: "default", color: "#00b7eb" }}
                >
                  Services
                </button>

                <h1 className="services-title mt-2 fs-3 fs-sm-2 fs-md-1 fw-bold">
                  What We Do <span className="font-red">Best</span>
                </h1>

                <p className="font-para">
                  We deliver cutting-edge solutions in Drone Technology, AI, IoT, and Robotics,
                  helping businesses innovate, automate, and scale efficiently.
                  <br />
                  From aerial intelligence to smart systems, we turn complex ideas into
                  practical, high-impact solutions.
                </p>
              </div>

              <button
                className="btn btn-red fw-semibold px-2 py-2 mb-3 mt-3 mt-md-0"
                onClick={handleClick}
              >
                EXPLORE ALL →
              </button>
            </div>

            {/* Services Grid */}
            <div className="row g-2">
              {services.map((service, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-3">
                  <div className="service-card">
                    <div className="d-flex flex-column h-100">
                      <div className="mb-3">{service.icon}</div>
                      <h3 className="service-title">{service.title}</h3>
                      <p
                        className="text-dark fw-semibold"
                        style={{ fontSize: "1rem" }}
                      >
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* our best gamess */}
        {/* <div>
          <div
            className=" container  text-dark position-relative bg-white"
            style={{ marginTop: "40px" }}
          >
            <div className="position-relative   ">
              <div className="row align-items-center min-vh-10 ">
                <div className="col-lg-4 mt-lg-0 hero-container">
                  <div
                    className=" d-flex flex-column flex-sm-row gap-3"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  ></div>
                  <button
                    className=" btn border border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                    style={{
                      color: "#00b7eb",
                    }}
                  >
                    OUR GAMES
                  </button>
                  <div className="d-flex flex-column gap-1">
                    <h3 className="display-5 mt-2 fw-bold fade-in-up delay-1">
                      <span className="d-block text-dark ">
                        Our Best <span className="font-red">Games</span>
                      </span>
                    </h3>

                    <p className="font-para text-dark fade-in-up delay-2">
                      A game studio crafting exciting, high-quality video games,
                      prioritizing immersive gameplay and mechanics.
                    </p>

                    <div className="d-flex gap-4 fade-in-up delay-3 ">
                      <button
                        className="btn btn-red text-white fw-semibold px-4 py-2"
                        onClick={handleClickGame}
                      >
                        Explore Games →
                      </button>
                    </div>
                  </div>
                </div>

                <style>
                  {`
          @keyframes continuousScroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }

          .scroll-wrapper:hover .scroll-track {
            animation-play-state: paused;
          }

          @media (max-width: 768px) {
            .responsive-image {
              height: 300px !important;
              width: 150px !important;
            }
          }
        `}
                </style>

                <div className="col-lg-8 mt-sm-4 mt-5 mt-sm-0">
                  <div
                    className="row row-cols-2 g-3 mx-auto"
                    style={{ maxWidth: "900px", width: "100%" }}
                  >
                    <div
                      className="scroll-wrapper position-relative w-100 overflow-hidden"
                      style={scrollWrapperStyle}
                    >
                      <div
                        className="scroll-track w-100 d-flex gap-3"
                        style={scrollTrackStyle}
                      >
                        {images1.map((image, index) => (
                          <div
                            key={`first-${index}`}
                            className="image-box rounded border bg-white overflow-hidden shadow-sm"
                            style={imageBoxStyle}
                          >
                            <img
                              src={image.src}
                              alt={`Image ${index + 1}`}
                              style={imageStyle}
                              className="img-fluid object-fit-cover responsive-image"
                            />
                          </div>
                        ))}

                        {images1.map((image, index) => (
                          <div
                            key={`second-${index}`}
                            className="image-box rounded border bg-white overflow-hidden shadow-sm"
                            style={imageBoxStyle}
                          >
                            <img
                              src={image.src}
                              alt={`Image ${index + 1}`}
                              style={imageStyle}
                              className="img-fluid object-fit-cover responsive-image"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <style>{`
                  .hero-container .animated-text {
                    background: linear-gradient(
                      45deg,
                      #dc3545 0%,
                      #ff6b6b 25%,
                      #ff1744 50%,
                      #dc3545 75%,
                      #ff6b6b 100%
                    );
                    background-size: 400% 400%;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    animation: colorWave 3s ease-in-out infinite,
                      textGlow 2s ease-in-out infinite alternate,
                      letterSpacing 4s ease-in-out infinite;
                    position: relative;
                  }

                  .animated-text::before {
                    content: "Our Best Gaming Team";
                    position: absolute;
                    top: 1px;
                    left: 1px;
                    background: linear-gradient(45deg, #dc3545, #ff1744);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    z-index: -1;
                    opacity: 0.4;
                    animation: shadowMove 3s ease-in-out infinite;
                  }

                  @keyframes colorWave {
                    0%,
                    100% {
                      background-position: 0% 50%;
                    }
                    50% {
                      background-position: 100% 50%;
                    }
                  }

                  @keyframes textGlow {
                    0% {
                      filter: brightness(1) contrast(1);
                      transform: scale(1);
                    }
                    100% {
                      filter: brightness(1.2) contrast(1.1);
                      transform: scale(1.02);
                    }
                  }

                  @keyframes letterSpacing {
                    0%,
                    100% {
                      letter-spacing: normal;
                    }
                    50% {
                      letter-spacing: 2px;
                    }
                  }

                  @keyframes shadowMove {
                    0%,
                    100% {
                      transform: translate(0, 0);
                    }
                    25% {
                      transform: translate(2px, 2px);
                    }
                    50% {
                      transform: translate(-1px, 1px);
                    }
                    75% {
                      transform: translate(1px, -1px);
                    }
                  }

                  .fade-in-up {
                    animation: fadeInUp 1s ease-out forwards;
                    opacity: 0;
                    transform: translateY(30px);
                  }

                  .fade-in-up.delay-1 {
                    animation-delay: 0.2s;
                  }
                  .fade-in-up.delay-2 {
                    animation-delay: 0.4s;
                  }
                  .fade-in-up.delay-3 {
                    animation-delay: 0.6s;
                  }

                  @keyframes fadeInUp {
                    to {
                      opacity: 1;
                      transform: translateY(0);
                    }
                  }

                  .btn-hover-effect {
                    position: relative;
                    overflow: hidden;
                    transition: all 0.3s ease;
                    z-index: 1;
                  }

                  .btn-hover-effect::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(
                      90deg,
                      transparent,
                      rgba(255, 255, 255, 0.2),
                      transparent
                    );
                    transition: left 0.5s ease;
                    z-index: -1;
                  }

                  .btn-hover-effect:hover::before {
                    left: 100%;
                  }

                  .btn-hover-effect:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
                  }

                  .floating-icons {
                    animation: float 3s ease-in-out infinite;
                  }

                  @keyframes float {
                    0%,
                    100% {
                      transform: translateY(0px);
                    }
                    50% {
                      transform: translateY(-5px);
                    }
                  }

                  .text-shimmer {
                    background: linear-gradient(
                      90deg,
                      #333 25%,
                      #666 50%,
                      #333 75%
                    );
                    background-size: 200% 100%;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    animation: shimmer 2s ease-in-out infinite;
                  }

                  @keyframes shimmer {
                    0% {
                      background-position: -200% 0;
                    }
                    100% {
                      background-position: 200% 0;
                    }
                  }
                `}</style>
              </div>
            </div>
          </div>

          <div className="container-fluid py-5 mt-5 mt-sm-0">
            <div className="container">
              <div ref={sectionRef} className="stats-section">
                <div className="row text-center gy-4">
                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="stat-item h-100 px-3 py-4">
                      <h2 className="mb-3">
                        <span
                          className="counter-value text-dark"
                          style={{
                            fontSize: "2.8rem",
                            fontWeight: "600",
                          }}
                        >
                          {counters.years}
                        </span>
                        <span className="stat-plus">+</span>
                      </h2>
                      <div className="stat-line mx-auto mb-2"></div>
                      <p className="font-para text-dark mb-0">
                        Years on the
                        <br />
                        market
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="stat-item h-100 px-3 py-4">
                      <h2 className="mb-3">
                        <span
                          className="counter-value text-dark"
                          style={{
                            fontSize: "2.8rem",
                            fontWeight: "600",
                          }}
                        >
                          {counters.specialists}
                        </span>
                        <span className="stat-plus">+</span>
                      </h2>
                      <div className="stat-line mx-auto mb-2"></div>
                      <p className="font-para text-dark mb-0">
                        Highly skilled
                        <br />
                        specialists
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="stat-item h-100 px-3 py-4">
                      <h2 className="mb-3">
                        <span
                          className="counter-value text-dark"
                          style={{
                            fontSize: "2.8rem",
                            fontWeight: "600",
                          }}
                        >
                          {counters.games}
                        </span>
                        <span className="stat-plus">+</span>
                      </h2>
                      <div className="stat-line mx-auto mb-2"></div>
                      <p className="font-para text-dark mb-0">
                        Games
                        <br />
                        completed
                      </p>
                    </div>
                  </div>

                  <div className="col-12 col-sm-6 col-lg-3">
                    <div className="stat-item h-100 px-3 py-4">
                      <h2 className="mb-3">
                        <span
                          className="counter-value text-dark"
                          style={{
                            fontSize: "2.8rem",
                            fontWeight: "600",
                          }}
                        >
                          {formatNumber(counters.clients, "K")}
                        </span>
                        <span className="stat-plus">+</span>
                      </h2>
                      <div className="stat-line mx-auto mb-2"></div>
                      <p className="font-para text-dark mb-0">
                        Clients
                        <br />
                        recommend us
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Technology */}
        <div
          className="bg-light"
          style={{ minHeight: "80vh", marginTop: "40px" }}
        >
          <div className="container py-4">
            {/* Header Section - Centered */}
            <div className="row justify-content-center text-center">
              <div className="col-lg-2 col-md-6 w-50 ">
                <button
                  className="btn border border-danger fw-semibold bg-transparent px-3 py-2 mt-2 rounded-pill fs-6 fs-md-5"
                  style={{
                    cursor: "default",
                    color: "#00b7eb",
                    // marginLeft: "-50px",
                  }}
                >
                  OUR TECHNOLOGY
                </button>
              </div>
              <div className="col-10 col-md-10 ">
                <h4 className="display-5 display-md-5 fw-bold font-dark">
                  Our Technology <span className="font-red">Stack</span>
                </h4>
              </div>
            </div>

            {/* Main Content Section - Centered */}
            <div className="row justify-content-center align-items-center">
              {/* Left Content - Centered */}
              <div className="col-lg-5 col-md-8 col-sm-6    fs-6 fs-md-6 fs-lg-6 mt-2 mb-lg-0 text-center text-lg-start">
                <h5 className="display-6 fw-bold mb-4 lh-1">
                  DELIVERING EXCELLENCE
                  <br />
                  IN
                  <br />
                  <span className="font-red">NEXT-GEN</span> TECHNOLOGY
                  <br />
                  SOLUTIONS
                </h5>

                <p className="font-para mb-2">
                  Our technology ecosystem powers intelligent solutions across Drone Technology,
                  Artificial Intelligence, IoT, and Robotics — enabling automation, real-time
                  insights, and scalable innovation for modern industries.
                </p>
                {/* Bottom Button - Centered */}
                <div className="row justify-content-start mt-3 mb-2 d-none d-lg-block">
                  <div className="col-auto">
                    <button
                      className="btn btn-red text-white fw-semibold px-4 py-2"
                      onClick={handleClickTech}
                    >
                      Explore Technology →
                    </button>
                  </div>
                </div>
              </div>

              {/* Right Grid Section - Perfectly Centered */}
              <div className="col-lg-7">
                <div className="row g-4 justify-content-center">
                  {/* First Row - 3 Tech Icons */}
                  {currentTechs.slice(0, 3).map((tech, index) => (
                    <div key={`card-${index}`} className="col-4 col-md-4">
                      <div
                        className="card border-0 shadow-sm h-100 bg-white border-2 border-light"
                        style={{ minHeight: "120px" }}
                      >
                        <div className="card-body d-flex align-items-center justify-content-center p-3">
                          <img
                            key={`${currentDomain}-${tech.name}-${index}-${animationKey}`}
                            src={tech.icon}
                            alt={tech.name}
                            className="img-fluid"
                            style={{
                              width: "75px",
                              height: "75px",
                              objectFit: "contain",
                              animation: `slideUpFade 0.6s ease-out ${index * 0.1
                                }s both`,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}

                  {/* Second Row - Domain Title Card + Logo */}
                  <div className="col-7 col-md-7">
                    <div
                      className={`card border-0 shadow h-100 ${domainColors.bg} text-white position-relative overflow-hidden`}
                      style={{ minHeight: "120px" }}
                    >
                      <div className="card-body d-flex align-items-center justify-content-center p-4">
                        <div className="text-center">
                          <h5 className="fs-3 mb-0 fw-bold font-red text-uppercase letter-spacing-wide">
                            {getDomainName(currentDomain)}
                          </h5>
                        </div>
                      </div>
                      <div className="position-absolute top-0 end-0 p-2">
                        <div
                          className="bg-white bg-opacity-20 rounded-circle"
                          style={{ width: "8px", height: "8px" }}
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="col-5 col-md-5 col-sm-5 ">
                    <div
                      className="card border-0 shadow-sm h-100 bg-white border-2 border-secondary "
                      style={{ minHeight: "120px" }}
                    >
                      <div className="card-body d-flex align-items-center justify-content-center p-1">
                        <div className=" text-white rounded-circle d-flex align-items-center justify-content-center">
                          <img
                            src={GameLogo}
                            className="shiv_games"
                            style={{ width: "auto", height: "55px" }}
                          />
                          <h6></h6>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Third Row - Last 3 Tech Icons */}
                  {currentTechs.slice(3, 6).map((tech, index) => (
                    <div key={`card-${index + 3}`} className="col-4 col-md-4">
                      <div
                        className="card border-0 shadow-sm h-100 bg-white border-2 border-light"
                        style={{ minHeight: "120px" }}
                      >
                        <div className="card-body d-flex align-items-center justify-content-center p-3">
                          <img
                            key={`${currentDomain}-${tech.name}-${index + 3
                              }-${animationKey}`}
                            src={tech.icon}
                            alt={tech.name}
                            className="img-fluid"
                            style={{
                              width: "75px",
                              height: "75px",
                              objectFit: "contain",
                              animation: `slideUpFade 0.6s ease-out ${(index + 3) * 0.1
                                }s both`,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Internal CSS Styles */}
          <style>{`
            @keyframes slideUpFade {
              from {
                opacity: 0;
                transform: translateY(30px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }

            .letter-spacing-wide {
              letter-spacing: 1px;
            }

            .bg-gradient {
              background: linear-gradient(45deg, #dc3545, #fd7e14) !important;
            }

            @media (max-width: 768px) {
              .display-4 {
                font-size: 2.5rem;
              }
              .display-5 {
                font-size: 2rem;
              }
            }
          `}</style>
        </div>

        {/* Trusted Clients */}
        {/* <div
          className="py-3 py-md-5"
          data-aos="fade-up"
          style={{ marginTop: "40px" }}
        >
          <div className="text-center mb-4 mb-md-5">
            <h3 className="display-5 display-md-5 fw-bold font-dark">
              Our Trusted <span className="font-red">Clients</span>
            </h3>
          </div>
          <div
            className="container-fluid px-3 px-md-4 d-flex justify-content-center align-items-center"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <div className="logo-track w-100">
              <div className="d-flex justify-content-center align-items-center gap-4 flex-nowrap mx-auto">
                {[l1, l2, l3].map((logo, idx) => (
                  <div
                    key={idx}
                    className="text-center d-flex justify-content-center"
                  >
                    <img
                      src={logo}
                      alt={`Client Logo ${idx + 1}`}
                      className="img-fluid logo-img"
                      style={{
                        maxHeight: "25px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div> */}

        {/* Optional CSS for additional styling */}
        <style>{`
          .logo-img {
            transition: transform 0.3s ease;
            opacity: 1;
            display: block;
            margin: 0 auto;
          }

          .logo-img:hover {
            transform: scale(1.05);
          }

          .logo-track .row {
            max-width: 800px;
            margin: 0 auto;
          }

          @media (max-width: 576px) {
            .logo-img {
              max-height: 45px !important;
            }
          }

          @media (min-width: 768px) {
            .logo-img {
              max-height: 70px !important;
            }
          }

          @media (min-width: 992px) {
            .logo-img {
              max-height: 80px !important;
            }

            .logo-track .row {
              justify-content: center !important;
              gap: 2rem;
            }
          }
        `}</style>

        {/* Testimonial */}
        <div
          className="container-fluid bg-light py-4"
          style={{ marginTop: "30px" }}
        >
          <div className="container " data-aos="fade-up">
            <div className=" d-flex ">
              <span
                className=" btn border border-danger d-flex fw-semibold  bg-transparent mt-2 mb-2 px-3 py-2 rounded-pill fs-6 fs-md-5"
                style={{ color: "#00b7eb" }}
              >
                TESIMONIAL
              </span>
            </div>

            <div
              className=" py-2 boxer-testimonial-container"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <div className="container">
                {/* Header */}
                <div className="row mb-5">
                  <div className="col-lg-8">
                    <h3
                      className="display-5 fw-bold fs-2 fs-sm-3 fs-md-3 responsive-heading text-uppercase mb-4"
                      style={{ fontSize: "3.5rem", letterSpacing: "2px" }}
                    >
                      OUR <span style={{ color: "#dc3545" }}>TESTIMONIAL</span>
                    </h3>
                    <p
                      className="font-para mb-0"
                      style={{ fontSize: "1.1rem", lineHeight: "1.6" }}
                    >
                      This platform redefined my gaming experience. From
                      lightning-fast matchmaking to immersive tournaments and
                      vibrant community engagement.
                    </p>
                  </div>
                  <div className="col-lg-4  d-flex align-items-center justify-content-end">
                    <button
                      className="btn rounded-circle border me-3 d-flex align-items-center justify-content-center"
                      onClick={prevSlidenew}
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "white",
                        borderColor: "#dc3545",
                        color: "#00b7eb",
                      }}
                    >
                      <ChevronLeft size={24} />
                    </button>
                    <button
                      className="btn rounded-circle border d-flex align-items-center justify-content-center"
                      onClick={nextSlidenew}
                      style={{
                        width: "50px",
                        height: "50px",
                        backgroundColor: "white",
                        borderColor: "#dc3545",
                        color: "#00b7eb",
                      }}
                    >
                      <ChevronRight size={24} />
                    </button>
                  </div>
                </div>

                {/* Main Content */}
                <div className="container">
                  <div className="row g-2 align-items-stretch">
                    {/* Testimonials Slider */}
                    <div className="col-12 col-lg-8">
                      <Slider {...settings} ref={sliderRef}>
                        {testimonialsPrev.map((testimonial) => (
                          <div key={testimonial.id} className="px-2 h-100">
                            <div className="bg-white p-3 shadow-sm rounded-3 h-100 d-flex flex-column justify-content-between">
                              {/* Quotation icon */}
                              <div className="mb-3">
                                <i className="bi bi-quote fs-1 font-red"></i>
                              </div>

                              {/* Testimonial text */}
                              <p className="fs-6 font-black flex-grow-1">
                                {testimonial.quote}
                              </p>

                              {/* Footer */}
                              <div className="d-flex align-items-center mt-3">
                                <img
                                  src={testimonial.image}
                                  alt={testimonial.name}
                                  className="rounded-circle me-3"
                                  width={50}
                                  height={50}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = `https://via.placeholder.com/70x70/dc3545/ffffff?text=${testimonial.name?.charAt(
                                      0
                                    )}`;
                                  }}
                                />
                                <div className="flex-grow-1">
                                  <h6 className="mb-0">{testimonial.name}</h6>
                                  <small className="text-muted d-block">
                                    {testimonial.role}
                                  </small>
                                  <div className="d-flex gap-1 mt-1">
                                    {renderStarsPrev(testimonial.rating)}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </Slider>
                    </div>

                    {/* Side Image */}
                    <div className="col-12 col-lg-4 d-none d-lg-block">
                      <div className="h-100 min-vh-25 position-relative">
                        <div className="rounded-3 overflow-hidden h-100 bg-black">
                          <img
                            src={test1}
                            alt="Master Upper Cut"
                            className="img-fluid w-100 h-100"
                            style={{ objectFit: "cover" }}
                            onError={(e) => {
                              e.target.src =
                                "https://via.placeholder.com/400x600/000000/dc3545?text=BOXER";
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Home Blog */}
        <HomeBlogSection />

        {/* Subscribe Now */}
        <div
          className="text-dark py-3 px-3 position-relative overflow-hidden bg-light"
          data-aos="fade-up"
          style={{ marginTop: "40px" }}
        >
          <div
            className="position-absolute top-0 start-0 w-100 h-100"
            style={{
              zIndex: 1,
            }}
          ></div>
          <div className="container position-relative" style={{ zIndex: 2 }}>
            <div className="row align-items-center">
              <div className="col-md-6 text-center text-md-start mb-4 mb-md-0">
                <h2 className="fw-bold mb-2 text-dark">
                  HAVE QUESTIONS? CONTACT US NOW
                </h2>
                <h2 className="fw-bold text-dark">
                  OUR TEAM IS HERE TO ASSIST YOU
                </h2>
              </div>
              <div className="col-md-6 d-flex justify-content-center justify-content-md-end">
                <div
                  className="input-group w-100"
                  style={{ maxWidth: "400px" }}
                >
                  <form
                    className="input-group w-100"
                    style={{ maxWidth: "400px" }}
                    onSubmit={handleSubscribe}
                  >
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Your Email Address"
                      value={subscriberEmail}
                      onChange={(e) => setSubscriberEmail(e.target.value)}
                      name="user_email" // this name is VERY important
                      required
                    />
                    <button
                      type="submit"
                      className="btn btn-danger text-white fw-bold subscribe-btn"
                    >
                      SUBSCRIBE NOW
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            backgroundImage: `url(${img23})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          data-aos="fade-up"
          data-aos-duration="4000"
        >
          <Container fluid className="py-5 px-4">
            <Row className="justify-content-center">
              <Col lg={10}>
                <Row className="gy-4">
                  <Col md={6} data-aos="fade-right" data-aos-delay="200">
                    <h3 className="display-5 text-white fw-bold mb-3">
                      Let's Talk About Your Project
                    </h3>
                    <p
                      className="text-white fw-semibold"
                      style={{ fontSize: "1.11rem", fontWeight: "450" }}
                    >
                      We are ready to discuss the details of your project and
                      answer any of your questions: just fill out the form
                      below.
                    </p>

                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-12 col-md-12 col-lg-6  col-sm-6 mb-3">
                          <div className="bg-white border rounded p-3 d-flex align-items-center">
                            <FaEnvelope className="me-3 font-red" />
                            <div>
                              <small className="text-dark fw-semibold d-block">
                                MAIL US
                              </small>
                              <span>info@theshivgames.com</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-12 col-lg-6 col-sm-6 mb-3">
                          <div className="bg-white border rounded p-3 d-flex align-items-center">
                            <FaSkype className="me-3 font-red" />
                            <div>
                              <small className="text-dark fw-semibold d-block">
                                SKYPE ID
                              </small>
                              <span>live:e572a321251b78e8</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12 col-md-12 col-lg-6  col-sm-6 mb-3">
                          <div className="bg-white border rounded p-3 d-flex align-items-center">
                            <FaPhone className="me-3 font-red" />
                            <div>
                              <small className="text-dark fw-semibold d-block">
                                CONTACT US
                              </small>
                              <span>+91 96550 22226</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-12 col-lg-6  col-sm-6 mb-3">
                          <div className="bg-white border rounded p-3 d-flex align-items-center">
                            <FaChartLine className="me-3 font-red" />
                            <div>
                              <small className="text-dark fw-semibold d-block">
                                FOR SALES
                              </small>
                              <span>+91 96550 22226</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} data-aos="fade-right" data-aos-delay="200">
                    <Form
                      className="bg-white p-4 rounded shadow-sm"
                      onSubmit={handleSubmit}
                      ref={form}
                    >
                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              <FaUser className="me-2" />
                              Full Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter your name"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              <FaEnvelope className="me-2" />
                              Email Address
                            </Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Enter email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              required
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              <FaPhone className="me-2" />
                              Phone Number
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter phone"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              <FaWhatsapp className="me-2" />
                              WhatsApp
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Whatsapp"
                              name="whatsapp"
                              value={formData.whatsapp}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              <FaBuilding className="me-2" />
                              Company Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Company Name"
                              name="companyName"
                              value={formData.companyName}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              <IoMdBuild className="me-2" />
                              Company Service
                            </Form.Label>
                            <Form.Select
                              name="companyService"
                              value={formData.companyService}
                              onChange={handleChange}
                            >
                              <option value="">Select Type</option>
                              <option value="Solo">Solo</option>
                              <option value="Pvt">Pvt</option>
                              <option value="Llp">Llp</option>
                              <option value="Startup">Startup</option>
                              <option value="Partnership">Partnership</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              <MdOutlineMiscellaneousServices className="me-2" />
                              Type of Service looking for?
                            </Form.Label>
                            <Form.Select
                              name="serviceType"
                              value={formData.serviceType}
                              onChange={handleChange}
                            >
                              <option value="">Select a Service</option>
                              <option value="Drone">Drone Solutions</option>
                              <option value="Robotics">Robotics Solutions</option>
                              <option value="IOT">Iot Solutions</option>
                              <option value="AI">Artificial Intelligence</option>
                              <option value="Software">
                                Software Development
                              </option>
                              <option value="App">App Development</option>
                              {/* <option value="Game">Game Development</option> */}
                              <option value="Website">
                                Website Development
                              </option>
                              <option value="AR & VR Development">
                                AR & VR Apps{" "}
                              </option>
                              {/* <option value="Website">Casino Api</option> */}
                              {/* <option value="Website">Devops Solutions</option> */}
                              {/* <option value="Website">It Support</option> */}
                              <option value="Website">Training Programs</option>
                              {/* <option value="Website">Digital Marketing</option> */}
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>
                              <FaGlobe className="me-2" />
                              Country
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Country"
                              name="country"
                              value={formData.country}
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Form.Group className="mb-3">
                        <Form.Control
                          as="textarea"
                          rows={4}
                          placeholder="Your Message *"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <button type="submit" className="btn-red">
                        SUBMIT →
                      </button>
                    </Form>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Home;
